export const territory_csv = `territoryID,territoryDescription,regionID
01581,Westboro,1
01730,Bedford,1
01833,Georgetown,1
02116,Boston,1
02139,Cambridge,1
02184,Braintree,1
02903,Providence,1
03049,Hollis,3
03801,Portsmouth,3
06897,Wilton,1
07960,Morristown,1
08837,Edison,1
10019,NewYork,1
10038,NewYork,1
11747,Melville,1
14450,Fairport,1
19428,Philadelphia,3
19713,Newark,1
20852,Rockville,1
27403,Greensboro,1
27511,Cary,1
29202,Columbia,4
30346,Atlanta,4
31406,Savannah,4
32859,Orlando,4
33607,Tampa,4
40222,Louisville,1
44122,Beachwood,3
45839,Findlay,3
48075,Southfield,3
48084,Troy,3
48304,BloomfieldHills,3
53404,Racine,3
55113,Roseville,3
55439,Minneapolis,3
60179,HoffmanEstates,2
60601,Chicago,2
72716,Bentonville,4
75234,Dallas,4
78759,Austin,4
80202,Denver,2
80909,ColoradoSprings,2
85014,Phoenix,2
85251,Scottsdale,2
90405,SantaMonica,2
94025,MenloPark,2
94105,SanFrancisco,2
95008,Campbell,2
95054,SantaClara,2
95060,SantaCruz,2
98004,Bellevue,2
98052,Redmond,2
98104,Seattle,2`;
